import { useState } from 'react';

// Criando um hook customizado para enviar WhatsApp
export function useWhatsapp() {
  const [loading, setLoading] = useState(false);

  const sendWhatsapp = async () => {
    const url = 'https://graph.facebook.com/v22.0/632276113301045/messages';
    const token = 'EAATdiTo9OHsBO3maGp0jZBYsIAgKdtcrVh46OJKdx7mtFvvLLHsZBjlOW7te2nJ7aIkJK5KUbLHQ129HWNkdcCEb9C3d9ytjpAiR97i5b3GMNZAR2ZACW22tHMrqDeZCAPDmZCNpqdWnnLkScQclRFAAZBaVw3F1ZC1675ZAUPjr2NXpEtp85cLSMyrDTHDPLeVfSQMWjZBk72bCam966ifhmO'; // seu token de autenticação

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };

    const body = JSON.stringify({
    messaging_product: "whatsapp",
    recipient_type: "individual",
    to: "558694451823",
    type: "interactive",
    interactive: {
    type: "cta_url",
    header: {
    type: "text",
    text: "Uma nova oportunidade apareceu!!!"
    },
    body: {
      text: "Um novo cliente em potencial apareceu acesse o crm para continuar com o processo.\n🚀🚀🚀"
    },
    action: {
    name: "cta_url",
    parameters: {
    display_text: "Acesse o wCrm",
    url: "https://crm.nextcompany.com.br"
      }
    }
  }
    });

    setLoading(true); // Define o loading como verdadeiro ao iniciar o envio da mensagem

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: body
      });

      if (response.ok) {
        console.log('Mensagem enviada com sucesso!');
      } else {
        console.error('Erro ao enviar a mensagem:', response.statusText);
      }
    } catch (error) {
      console.error('Erro de rede:', error);
    } finally {
      setLoading(false); // Define o loading como falso quando o processo terminar
    }
  };

  // Retorna a função sendWhatsapp e o estado de carregamento
  return { sendWhatsapp, loading };
}
